import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import CloseIcon from '../../assets/images/close-icon.svg';
import css from './close-button.scss';

const CloseButton = ({ onClose, className }) => {
    const classes = className ? `${className} ${css['close-button']}` : css['close-button'];
    return (
        <div
            className={classes}
            onClick={onClose}
            role="button"
            tabIndex="0"
        >
            <Isvg src={CloseIcon} />
        </div>
    );
};

CloseButton.propTypes = {
    onClose: PropTypes.func,
    className: PropTypes.string
};

export default CloseButton;



// WEBPACK FOOTER //
// ./components/close-button/close-button.js